import { AxiosService } from "./AxiosService";

const baseUrl = "azure";
const axiosService = AxiosService(process.env.REACT_APP_API_URL)

export const AzureService = {
    async getMarketingContent(role) {
        return await axiosService.getRequest(`${baseUrl}/${role}/marketing`);
    }
}